import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment as env } from '@env/environment';
import { InterceptorSkipHeader } from '@services/auth-interceptor.service';


@Injectable({ providedIn: 'root' })
export class AuthAppleService {
  constructor(private http: HttpClient) {}

  loginWithAppleCredential(credential: string) {
  const headers = new HttpHeaders().set(InterceptorSkipHeader, '1');
  return this.http.post<{ token: string; user: any }>(
    `${env.apiUrl}/sso/apple/callback`,
    { credential },
    { headers }
  );
}

registerWithApple(body: { credential: string; cpf_cnpj: string; name: string; phone_country_code?: string; phone?: string }) {
  const headers = new HttpHeaders()
    .set(InterceptorSkipHeader, '1')
    .set('platform', 'WEB');
  return this.http.post(`${env.apiUrl}/user/apple`, body, { headers });
}
}
